import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Row, Col, Button } from 'antd'

import './index.css'

import Logo from 'assets/images/ekko-logo.png'

class End extends React.Component {
    render() {
        const { applicationId } = this.props

        return (
            <Col xs={22} sm={18} md={14}>
                <img src={Logo} height="42" />
                <h2 style={{ paddingTop: 50, marginBottom: 20 }}>Thanks for using Ekko!</h2>
                <h2 style={{ paddingTop: 50, marginBottom: 20 }}>
                    If you followed the guidelines correctly, Ekko should be working fine on your website. If you missed
                    a step during the tutorial, you can still access it from the Dashboard.
                </h2>

                <div style={{ paddingTop: 40 }}>
                    {applicationId ? (
                        <Link to={`/${applicationId}/dashboard`}>
                            <Button type="primary">Go to Dashboard</Button>
                        </Link>
                    ) : (
                        <Link to="/">
                            <Button type="primary">Get Started!</Button>
                        </Link>
                    )}
                </div>
            </Col>
        )
    }
}

const mapStateToProps = ({ ekko }) => ({
    applicationId: ekko.currentAppId
})

export default connect(
    mapStateToProps,
    null
)(End)
